module.exports = __webpack_public_path__ + "img/LogoMilan.e55a54ad.png";